@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;
@use '@hevoio/hevo-ui-toolkit/styles/mixins' as hevo-toolkit-mixins;

.expandJSONButton {
  @include  hevo-toolkit-mixins.clear-btn-style();
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius:  hevo-toolkit-variables.$border-radius-sm;
  border: solid hevo-toolkit-variables.$border-width hevo-toolkit-variables.$divider-color;
  background-color:  hevo-toolkit-variables.$tooltip-bg !important;
}
